export const cobrandingPrefixText = ({cobranding_prefix, cobrandable}) => `${cobranding_prefix} ${cobrandable.name}`

export const hasEverplansCobranding = ({enabled, style}) => enabled && style === 'everplans_branded'

export const hasWhiteLabelCobranding = ({enabled, style}) => enabled && style === 'white_label'

export const isCobrandableTypePartner = ({cobrandable_type}) => cobrandable_type === 'Partner'
